import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LiveAnnouncerService {
  private _announce = new Subject<string>();

  announce(message: string) {
    this._announce.next(message);
  }

  getAnnounce() {
    return this._announce.asObservable();
  }
}